import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Typography } from 'seagull';
import { ExclamationMark } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { getRowErrorMessage, getGlobalErrorMessage } from '../BulkBillingModal.utils';
import styles from './ValidationErrors.module.scss';
export const GetValidationErrorsTestIds = ()=>getTestIds();
export const ValidationErrors = (param)=>{
    let { errors } = param;
    const { t: globalBillingHubTexts } = useLocaleKeys('pages.globalBillingHub');
    const { ValidationErrorsTestIds } = useMemo(()=>GetValidationErrorsTestIds(), []);
    const errorMessages = useMemo(()=>{
        var _errors_globalErrors, _errors_rowErrors;
        return [
            ...((_errors_globalErrors = errors.globalErrors) === null || _errors_globalErrors === void 0 ? void 0 : _errors_globalErrors.map((error)=>getGlobalErrorMessage(error))) || [],
            ...((_errors_rowErrors = errors.rowErrors) === null || _errors_rowErrors === void 0 ? void 0 : _errors_rowErrors.map((error)=>getRowErrorMessage(error))) || []
        ];
    }, [
        errors
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        testId: ValidationErrorsTestIds.Container(),
        className: styles.validationErrors,
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.header,
                children: [
                    /*#__PURE__*/ _jsx(ExclamationMark, {}),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        children: globalBillingHubTexts.listCantBeImported()
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.errorsContent,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph2",
                        children: globalBillingHubTexts.details()
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: styles.errorsContentErrors,
                        children: errorMessages.map((message, index)=>/*#__PURE__*/ _jsx("li", {
                                "data-testid": ValidationErrorsTestIds.Error(index),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    children: message
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
};
